var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup noselect"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Posudok")]), _c('button', {
    staticClass: "w-button"
  }, [_vm._v("Uložiť")])]), _vm._m(0), _vm._m(1), _c('div', {
    staticClass: "add-file-wrapper"
  }, [_c('label', {
    staticClass: "sub-ctass image-upload-btn add-file-button pointer blc-color pop-500",
    attrs: {
      "for": 'file-upload'
    }
  }, [_vm._v(" + nahrajte znalecký posudok "), _c('input', {
    attrs: {
      "id": 'file-upload',
      "type": "file",
      "accept": ".zip,.rar,.7zip"
    }
  })])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "vseob.hodnota"
    }
  }, [_vm._v("Všeobecná hodnota:")]), _c('input', {
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "name": "vseob.hodnota",
      "data-name": "vseob.hodnota",
      "id": "vseob.hodnota",
      "required": ""
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "bud.hodnota"
    }
  }, [_vm._v("Budúca hodnota:")]), _c('input', {
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "name": "bud.hodnota",
      "data-name": "bud.hodnota",
      "id": "bud.hodnota",
      "required": ""
    }
  })]);

}]

export { render, staticRenderFns }